import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';
import AnimatedSection from './AnimatedSection';
import LazyImage from './LazyImage';
import { VintageFrame, HandDrawnDivider, OrnamentalCorner } from './DecorativeElements';

const About = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="about" className="section-padding bg-rustic-cream texture-overlay">
      <div className="container mx-auto">
        <AnimatedSection animation="fadeInUp">
          <div className="text-center mb-16">
            <h2 className="section-heading">{t.about.title}</h2>
            <HandDrawnDivider />
          </div>
        </AnimatedSection>

        <AnimatedSection animation="fadeInUp" delay={200}>
          <div className="max-w-4xl mx-auto mb-16 relative">
            <OrnamentalCorner position="top-left" />
            <OrnamentalCorner position="top-right" />
            <OrnamentalCorner position="bottom-left" />
            <OrnamentalCorner position="bottom-right" />
            <VintageFrame>
              <p className="text-lg md:text-xl text-deep-brown leading-relaxed text-center font-body">
                {t.about.description}
              </p>
            </VintageFrame>
          </div>
        </AnimatedSection>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <AnimatedSection animation="slideInLeft" delay={300}>
            <div className="card-rustic">
              <LazyImage 
                src="/img/SAM_3991.JPG" 
                alt="Special Events" 
                className="w-full h-64"
              />
              <div className="p-6">
                <h3 className="text-2xl font-serif text-deep-brown mb-2">
                  {t.about.card1}
                </h3>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection animation="slideInRight" delay={400}>
            <div className="card-rustic">
              <LazyImage 
                src="/img/SAM_4008.JPG" 
                alt="Proposals and Engagement Parties" 
                className="w-full h-64"
              />
              <div className="p-6">
                <h3 className="text-2xl font-serif text-deep-brown mb-2">
                  {t.about.card2}
                </h3>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default About;
